/* eslint-disable yoda */
import { arrayMove } from '@dnd-kit/sortable';

/**
 * Reorders the media array and recalculates the sort_order and cover type for all items.
 * @param {Array} currentMedia The current array of media items.
 * @param {number} oldIndex The starting index of the dragged item.
 * @param {number} newIndex The target index where the item was dropped.
 * @returns {Array} A new array with items in the new order, updated sort_order, and correct 'cover' type.
 */
export const reorderAndFormatMedia = (currentMedia, oldIndex, newIndex) => {
  // 1. Move the item to its new position
  const reorderedMedia = arrayMove(currentMedia, oldIndex, newIndex);

  // 2. Map and apply new sort order and 'cover' type rule
  const finalMedia = reorderedMedia.map((item, index) => {
    const newSortOrder = index + 1;
    let newType = item.type;

    // Rule: Only the item at index 0 can be 'cover'
    if (index === 0) {
      newType = 'cover';
    } else if (item.type === 'cover') {
      // If an item was 'cover' but is no longer at index 0, clear the type
      newType = '';
    }

    return {
      ...item,
      sortOrder: newSortOrder,
      type: newType
    };
  });

  return finalMedia;
};
